import axios from 'axios';

import { errorOccuredWithNotificationAction as errorOccuredAction } from '../../app/redux/actions/errors';
import { signOutAction } from '../../app/redux/actions/usersActions';
import store from '../../app/store';
import { UNAUTHORIZED_USER_STATUS } from '../consts/index';

const apihost = '/api';

function makeUrl(uri, options = {}, host = apihost) {
  return `${host}/${uri}?api_key=${store.getState().users.currentUser.apikey}`;
}

export const loadSettings = (params, callback) => {
  return axios
    .get('/settings')
    .then((items) => {
      callback(items.data);
    })
    .catch((error) => {
      catchErrorToSignOut(error);
      return Promise.reject(error);
    });
};

export const loadPublishersPostbacks = (data, callback) => {
  return axios
    .post(makeUrl('postbacks'), JSON.stringify(data), {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((items) => {
      callback(items.data, items.data.total);
      return items.data;
    })
    .catch((error) => {
      catchErrorToSignOut(error);
      return Promise.reject(error);
    });
};

export const updateUser = (data) => {
  return axios
    .put(makeUrl('profile'), data)
    .then((response) => response)
    .catch((error) => {
      catchErrorToSignOut(error);
      return Promise.reject(error);
    });
};

export const getUserData = (data) => {
  return axios.get(makeUrl('me'), data).catch((error) => {
    catchErrorToSignOut(error);
    return Promise.reject(error);
  });
};

export const getUnregisteredUserData = (data) => {
  return axios.get(`${apihost}/me?api_key=${data}`);
};

export const loadCampaigns = (params, callback) => {
  return axios
    .get(makeUrl('campaigns'), { params: params })
    .then((items) => {
      callback(items.data);
      return items.data;
    })
    .catch((error) => {
      catchErrorToSignOut(error);
      return Promise.reject(error);
    });
};

export const loadReferrals = (params) => {
  return axios
    .get(makeUrl('referrals'), { params: params })
    .then((resource) => resource)
    .catch((error) => {
      catchErrorToSignOut(error);
      return Promise.reject(error);
    });
};

export const loadConversionReport = (params = {}, callback) => {
  return axios
    .get(makeUrl('reports/conversions'), { params: params })
    .then((items) => {
      callback(items.data);
    })
    .catch((error) => {
      catchErrorToSignOut(error);
      return Promise.reject(error);
    });
};

export const loadTrafficReport = (params = {}, callback) => {
  return axios
    .get(makeUrl('reports/traffic'), { params: params })
    .then((items) => {
      callback(items.data);
    })
    .catch((error) => {
      const { response } = error;
      if (response && response.data) {
        store.dispatch(errorOccuredAction(response.data));
      }
      catchErrorToSignOut(error);
      return Promise.reject(error);
    });
};

export const loadPayments = (params, callback) => {
  return axios
    .get(makeUrl('payments'), { params: params })
    .then((resource) => resource)
    .catch((error) => {
      catchErrorToSignOut(error);
      return Promise.reject(error);
    });
};

export const loadStat = (params, callback) => {
  return axios
    .get(makeUrl('stat'), { params: params })
    .then((items) => {
      callback(items.data);
    })
    .catch((error) => {
      catchErrorToSignOut(error);
      return Promise.reject(error);
    });
};

export const catchErrorToSignOut = (error) => {
  if (error.response && error.response.status === UNAUTHORIZED_USER_STATUS) {
    store.dispatch(signOutAction);
  }
};

export const signout = () => {
  console.log('sign out');
};
